<form class="itinerary-model-content-inner"  [formGroup]="packageDetailsForm">
  <div class="itinerary-model-content">
    <div class="ion-no-padding">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Details</ion-title>
    </div>
    <div class="form-container ion-padding-horizontal">
      <div class="row">
        <div class="col-6">
          <div class="input-container">
            <label for="" class="label">Package Title*</label>
            <div [ngClass]="{ 'invalid-input': packageDetailsForm.get('packageTitle')?.invalid && packageDetailsForm.get('packageTitle')?.touched }">
              <input type="text" class="input input-text" formControlName="packageTitle" placeholder="Enter Package Title">
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="input-container">
            <label for="" class="label">Package Reference ID</label>
            <div [ngClass]="{ 'invalid-input': packageDetailsForm.get('packageReferenceId')?.invalid && packageDetailsForm.get('packageReferenceId')?.touched }">
              <input type="text" class="input input-text" formControlName="packageReferenceId" placeholder="Package Reference Number">
            </div>
          </div>
        </div>
      </div>

      <ng-container formArrayName="destinations">
        <div class="destinations-days-row row" *ngFor="let item of destinationDaysArray.controls; let i = index" [formGroupName]="i">
          <div class="col-3" >
            <div class="input-container">
              <label for="" class="label">Destination {{i+1}}*</label>
              <div [ngClass]="{ 'invalid-input': item.get('location')?.invalid && item.get('location')?.touched }">
                <app-locations-autocomplete formControlName="location" [placeHolder]="'Enter Destination'"></app-locations-autocomplete>
              </div>
            </div>
            
          </div>

          <div class="col-2">
            <div class="input-container">
              <label for="" class="label">Nights*</label>
              <div [ngClass]="{ 'invalid-input': item.get('days')?.invalid && item.get('days')?.touched }" >
                <app-increment-number-input formControlName="days" [max]="365"></app-increment-number-input>
              </div>
            </div>
          </div>

          <div class="col-1 position-relative">
            <div class="btns-container">
              <ion-button class="add-btn action-btn" (click)="addDestination()" *ngIf="i+1 === destinationDaysArray.controls.length"><ion-icon name="add-outline"></ion-icon></ion-button>
              <ion-button class="delete-btn action-btn" (click)="removeDestination(i)" *ngIf="destinationDaysArray.controls.length !== 1"><ion-icon name="trash-outline"></ion-icon></ion-button>
            </div>
          </div>

          <div class="col-3" *ngIf="i === 0">
            <div class="input-container">
              <label for="" class="label" >Total Nights & Days</label>
              <div>
                <input type="text" class="input" [value]="getTotalNightsAndDays" disabled>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div *ngIf="item.get('destinationDays')?.invalid && item.get('destinationDays')?.touched">
              <p class="text-danger warning-message">Please enter a valid destination and number of days</p>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="row">
        <div class="col-3">
          <div class="input-container">
            <label for="" class="label">Package Valid From*</label>
            <div [ngClass]="{ 'invalid-input': packageDetailsForm.get('packageStartDate')?.invalid && packageDetailsForm.get('packageStartDate')?.touched }">
              <app-date-picker [minDate]="today()" formControlName="packageStartDate"></app-date-picker>
            </div>
          </div>
        </div>

        <div class="col-3">
          <div class="input-container">
            <label for="" class="label">Package Valid To*</label>
            <div [ngClass]="{ 'invalid-input': packageDetailsForm.get('packageEndDate')?.invalid && packageDetailsForm.get('packageEndDate')?.touched }">
              <app-date-picker [minDate]="packageDetailsForm.get('packageStartDate')?.value" formControlName="packageEndDate"></app-date-picker>
            </div>
          </div>
        </div>

        <div class="col-3">
          <div class="input-container">
            <label for="" class="label">Package Type</label>
            <div [ngClass]="{ 'invalid-input': packageDetailsForm.get('packageType')?.invalid && packageDetailsForm.get('packageType')?.touched }">
              <app-dropdown-select [dropdownValues]="dmcPackages" formControlName="packageType"></app-dropdown-select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-9">
          <div class="input-container">
            <label for="" class="label">Notes</label>
            <div [ngClass]="{ 'invalid-input': packageDetailsForm.get('notes')?.invalid && packageDetailsForm.get('notes')?.touched }">
              <app-text-formatting-input formControlName="notes"></app-text-formatting-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    

  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn invisible" type="button">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="!packageId || formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>


